const LANGUAGES = ['en-US', 'zh', 'ja', 'ko', 'es']

const DEFAULT_LANG = 'en-US'

module.exports = { LANGUAGES, DEFAULT_LANG }
